import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import Img from '../../assets/images/img-left.png';
import './style.scss';

const Information = ({ handleStart }) => (
  <section className="information">
    <Container>
      <Row>
        <Col xs={12}>
          <h1 className="text-center">BẠN ĐANG BOĂN KHOĂN VỀ VIỆC CHỌN NGÀNH</h1>
        </Col>
        <Col md={7} xs={12}>
          <img className="img-fluid" src={Img} alt="Trung tam phat trien nang luc" />
        </Col>
        <Col xs={12} md={5} className="description">
          <h3>Hãy thử làm các công cụ định hướng bên trên</h3>
          <p>
            {`Keep a competitive edge by truly understanding the voice of your customers.
              Customer satisfaction surveys help you connect at multiple touchpoints to find out exactly what your customers want, need, and expect.`}
          </p>
          <p className="text-center">
            <Button onClick={handleStart} className="bounce" variant="success">Bắt đầu ngay</Button>
          </p>
        </Col>
      </Row>
    </Container>

  </section>
);

Information.propTypes = {
  handleStart: PropTypes.func.isRequired
};

export default Information;
